export const LegalStatusApiDto = Symbol.for('LegalStatusApiDto');
